import React from "react";
import Loadable from "../../react-loadable";

const WeaQRcode = Loadable({
  loader: () => import("./Qrcode"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaQRcode;



// WEBPACK FOOTER //
// ./ecology9/wea-qrcode/index.js